import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import customInputStyle from './CustomInputStyle';

export const defaultMaskProps = {
    mask: '',
};

class CustomInput extends Component {
    onChange = (event) => {
        const { pattern, inputProps } = this.props;
        const value = event.target.value || '';

        if (pattern && value) {
            const validValue = new RegExp(pattern).test(value);

            if (validValue) {
                inputProps.onChange(event);
            }

            return;
        }

        inputProps.onChange(event);
    };

    getClasses = () => {
        const {
            classes,
            labelText,
            error,
            success,
            className,
        } = this.props;

        const labelClasses = clsx({
            [` ${classes.labelRootError}`]: error,
            [` ${classes.labelRootSuccess}`]: success && !error,
        });
        const underlineClasses = clsx({
            [classes.underlineError]: error,
            [classes.underlineSuccess]: success && !error,
            [classes.underline]: true,
            [className]: true,
        });
        const marginTop = clsx({
            [classes.marginTop]: labelText === undefined,
        });

        return { labelClasses, underlineClasses, marginTop };
    };

    getInput = ({ underlineClasses, marginTop }) => {
        const {
            id,
            classes,
            inputProps,
            maskProps,
            testId = 'input',
        } = this.props;

        const { value, disabled } = inputProps;
        const overriddenInputProps = { ...inputProps };

        delete overriddenInputProps.value;
        delete overriddenInputProps.onChange;
        delete overriddenInputProps.disabled;

        return (
            <InputMask
                {...defaultMaskProps}
                {...maskProps}
                disabled={disabled}
                value={value}
                onChange={this.onChange}
            >
                {(maskInputProps) => <Input
                    {...maskInputProps}
                    {...overriddenInputProps}
                    id={id}
                    data-test-id={testId}
                    classes={{
                        root: marginTop,
                        input: classes.input,
                        disabled: classes.disabled,
                        underline: underlineClasses,
                    }}
                />
                }
            </InputMask>
        );
    };

    getTextArea = ({ underlineClasses, marginTop }) => {
        const {
            id,
            inputProps,
            classes,
            testId = 'input',
            placeholder,
        } = this.props;

        return (
            <Input
                {...inputProps}
                onChange={this.onChange}
                id={id}
                data-test-id={testId}
                placeholder={placeholder}
                classes={{
                    root: marginTop,
                    input: classes.input,
                    disabled: classes.disabled,
                    underline: underlineClasses,
                }}
            />
        );
    };

    render() {
        const {
            id = '',
            inputProps = {},
            formControlProps = {},
            classes = {},
            labelText = '',
            labelProps = '',
            maskProps,
        } = this.props;
        const { labelClasses, underlineClasses, marginTop } = this.getClasses();

        return (
            <FormControl
                {...formControlProps}
                className={`${formControlProps.className} ${classes.formControl}`}
            >
                {labelText !== undefined ? (
                    <InputLabel
                        data-test-id='input-label'
                        className={classes.labelRoot + labelClasses }
                        classes={{ shrink: classes.labelShrink }}
                        htmlFor={id}
                        {...labelProps}
                    >
                        {labelText}
                    </InputLabel>
                ) : null}
                {(() => {
                    if (inputProps.multiline || !maskProps) {
                        return this.getTextArea({ labelClasses, underlineClasses, marginTop });
                    }

                    return this.getInput({ labelClasses, underlineClasses, marginTop });
                })()}
            </FormControl>
        );
    }
}

CustomInput.propTypes = {
    testId: PropTypes.string,
    classes: PropTypes.object.isRequired,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    maskProps: PropTypes.object,
    pattern: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.any,
    success: PropTypes.bool,
    placeholder: PropTypes.string,
};

export default withStyles(customInputStyle)(CustomInput);
